var _ellipse, _path, _rect, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndividualGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.64 63.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.32,
    cy: 21.32,
    rx: 14.14,
    ry: 18.28,
    fill: "#4d4d4d"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.32,40.96c-11.83,0-22.24,3.61-28.32,9.09,6.66,8.27,16.87,13.57,28.32,13.57s21.66-5.3,28.32-13.57c-6.08-5.48-16.49-9.09-28.32-9.09Z",
    fill: "#4d4d4d"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.34,
    y: 27.27,
    width: 13.96,
    height: 23.09,
    rx: 6.98,
    ry: 6.98,
    fill: "#4d4d4d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.13,22.17c.82,2.37,.5,4.64-.73,5.06-1.23,.43-2.89-1.15-3.71-3.52-.82-2.37-.5-4.64,.73-5.06,1.23-.43,2.89,1.15,3.71,3.52Z",
    fill: "#4d4d4d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.51,22.17c-.82,2.37-.5,4.64,.73,5.06,1.23,.43,2.89-1.15,3.71-3.52,.82-2.37,.5-4.64-.73-5.06-1.23-.43-2.89,1.15-3.71,3.52Z",
    fill: "#4d4d4d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.95,22.09c-1.84-3.34-3.73-6.89-3.63-10.7,.09-3.81,3-7.84,6.81-7.7,.67,.02,1.33,.17,1.99,.08,1.32-.19,2.3-1.27,3.36-2.06C26.89-.08,30.25-.51,33.03,.63c1.72,.7,3.17,1.92,4.85,2.72,3.12,1.48,6.97,1.33,9.96-.4-.62,1.17-1.68,2.11-2.92,2.59,1.14,.36,2.41,.33,3.53-.1-.68,1.22-1.79,2.2-3.1,2.7,.97,.07,1.94,.13,2.9,.2-.83,1.17-2.01,2.09-3.34,2.6,.76,.02,1.52,.05,2.28,.07-.57,1.67-2.03,3.01-3.75,3.43,.49,0,.98,.01,1.47,.02-1.6,2.31-3.2,4.62-4.81,6.94-.46,.66-.93,1.34-1.61,1.77-.56,.36-1.22,.53-1.88,.67-4.75,1.06-9.66,1.38-14.5,.94-1.66-.15-3.39-.42-4.71-1.44-1.32-1.02-2.02-3.01-1.12-4.4",
    fill: "#4d4d4d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.21,44.41c.1-1.92,.34-3.83,.71-5.71,.95,1.08,2.56,1.22,4,1.28,2.18,.09,4.36,.18,6.54,.27,.25,1.49,.43,3.23-.64,4.29-.5,.49-1.19,.73-1.86,.92-1.47,.41-2.99,.62-4.52,.63-1.81,.01-3.96-.53-4.54-2.24,.2-.16,.39-.32,.59-.48",
    fill: "#4d4d4d"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.44,44.41c-.1-1.92-.34-3.83-.71-5.71-.95,1.08-2.56,1.22-4,1.28-2.18,.09-4.36,.18-6.54,.27-.25,1.49-.43,3.23,.64,4.29,.5,.49,1.19,.73,1.86,.92,1.47,.41,2.99,.62,4.52,.63,1.81,.01,3.96-.53,4.54-2.24-.2-.16-.39-.32-.59-.48",
    fill: "#4d4d4d"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividualGrey);
export default __webpack_public_path__ + "static/media/IndividualGrey.c4717eb7489c9d7fcdbda5b648f8dd76.svg";
export { ForwardRef as ReactComponent };